import { npcs } from '../data/guide/npcs'
import { entityImages } from '../data/guide/entityImages'
import type { Monster, WorldData } from '../types/world'

/**
 * 06_monsters.csv (como el Monster.txt del servidor) mezcla monstruos, NPC y objetos en la misma tabla.
 * La guía los separa así, sin tocar los archivos:
 * - NPC de la guía (data/guide/npcs) o marcado como NPC por el staff en las imágenes.
 * - NPC que entrega misiones (npc_monster_id en quest_rules).
 * - Nivel 0 o sin nivel: en estos archivos son NPC, guardias, puertas, estatuas u otros objetos, no monstruos para cazar.
 */
export type MonsterKind = 'monstruo' | 'npc'

/**
 * Decisión del staff (11/10/2026): en la lista de monstruos y en el buscador solo aparecen los monstruos con foto.
 * Los archivos no cambian y sus fichas siguen accesibles desde drops, spots y misiones (sin enlaces rotos).
 * Poner en false para volver a mostrarlos todos.
 */
export const HIDE_MONSTERS_WITHOUT_PHOTO = true

const cache = new WeakMap<WorldData, Set<number>>()

function npcIds(w: WorldData): Set<number> {
  const hit = cache.get(w)
  if (hit) return hit
  const ids = new Set<number>()
  npcs.forEach((n) => n.monsterId !== undefined && ids.add(n.monsterId))
  entityImages.forEach((e) => e.kind === 'npc' && e.monsterId !== undefined && ids.add(e.monsterId))
  w.quests?.rules.forEach((r) => r.npcMonsterId !== undefined && ids.add(r.npcMonsterId))
  cache.set(w, ids)
  return ids
}

export function monsterKind(w: WorldData, m: Monster): MonsterKind {
  if (npcIds(w).has(m.id)) return 'npc'
  if (!m.level) return 'npc'
  return 'monstruo'
}
